<template>
  <div class="directory-tree">
    <DirectoryTreeNode
      v-for="dir in directories"
      :key="dir.id"
      :directory="dir"
      :selected-id="selectedId"
      :level="0"
      @select="onSelect"
    />
    <div v-if="directories.length === 0" class="empty-text">{{ $I18N("暂无目录") }}</div>
  </div>
</template>

<script setup>
import DirectoryTreeNode from './DirectoryTreeNode.vue'

defineProps({
  directories: {
    type: Array,
    required: true
  },
  selectedId: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['select'])

function onSelect(id) {
  emit('select', id)
}
</script>